<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"  :data-backdrop="modalBackdrop" data-keyboard="false" :class="{ 'remove-right-padding': isFullWidthMobile }">
        <div  class="modal-dialog-centered modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-width modal-content text-center modal-content-container">
                <div>
                    <div class="text-left modal-header1">
                        <h4>{{headerText}}</h4>
                    </div>
                    <p class="text-left m-0" v-html="modalText"></p>
                </div>
                <div v-if="!linkButton" class="modal-footer1 d-print-none mt-4 justify-content-center">
                        <button type="button" @click="$emit('onClose')" class="btn btn-primary w-100">
                            {{ returnToPageText }}
                        </button>
                </div>

                <div v-else class="modal-footer1 d-print-none d-flex">
                        <button type="button" @click="$emit('onClose')" class="btn btn-outline-primary w-50 font-weight-bold">
                            {{ returnToPageText }}
                        </button>
                        <a :href="routeTo" target="_blank" @click="$emit('onRouteTo')" class="bg-portal-primary-blue btn text-white font-weight-bold w-50 ml-2"  role="button" aria-haspopup="true">
                            {{ linkButtonText }}
                        </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import './msk.modal.scss'
    
    export default {
        props: {
            headerText: { type: String },
            returnToPageText: { type: String },
            linkButtonText: { type: String },
            modalText: { type: String },
            routeTo: { type: String },
            modalBackdrop: { type: String, default: "static" }
        },
        computed: {

            linkButton: function() {
              return this.linkButtonText != undefined && this.linkButtonText.length > 0;
            },

            dialogWidthCss: function () {
                return 'modal-xs-100 modal-sm-100 modal-md-75 modal-lg-70 modal-xl-75';
            },
            isFullWidthMobile: function () {
                return this.dialogWidthCss.indexOf('modal-xs-100') > -1 || this.dialogWidthCss.indexOf('modal-sm-100') > -1;
            }
        }
    }

</script>